import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, HttpClientService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { throwError } from 'rxjs';

import { HttpResponse, HttpHeaders } from '@angular/common/http';
import { ANALYTICS_CONSTANTS } from 'config';
declare var ENV_PORTAL;
@Injectable()
export class AddUserService {

  constructor(private utilityService: UtilityService,
    private httpClientService: HttpClientService, private adobeAnalyticsService: AdobeAnalyticsService) { }


  handleError = (error) => {
    return throwError(error);
  }



  getCreateUserDetails() {
    return this.httpClientService.get(this.utilityService.getEnvConfig().createUserUrl).pipe(
      map((res: HttpResponse<any>) => {
        return res.body;
      }),catchError(this.handleError));
  }


  saveUserDetails(url, userObj, companyId) {
    const headers = new HttpHeaders();
    url = this.httpClientService.replaceTextInUrl('{companyid}', companyId, url);
    return this.httpClientService.authorizedPut(url, userObj, headers).pipe(
      map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      }),catchError(this.handleError));
  }

  createPageLoadProperties(url: string, title: string, friendlyPageName: string) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = friendlyPageName;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_MANAGE;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';  
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }
}

